
import { HelpWrapper, FlexBox } from './styles';
import { ReactElement } from 'react';
type props = {
  title: string
  callCenter: string
  email: string
  img: string
};
export default function Help(props: Readonly<props>): ReactElement {
  return (
      <HelpWrapper>
        { props.title }
        <FlexBox>
          <div>
            <p>
              <a href={`https://wa.me/${props.callCenter}`} target="_blank">
                Atendimento via WhatsApp
              </a>
            </p>
            <p>
              { props.email }
            </p>
          </div>
            <img src={ props.img } alt="" />
        </FlexBox>
      </HelpWrapper>
  );
}
